var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.hasProcuration
      ? _c(
          "div",
          [
            _c("budgetary-estimate-view", {
              attrs: {
                budgetaryEstimate: _vm.budgetaryEstimate,
                specification: _vm.specification,
                applicationYear: _vm.applicationYear
              }
            }),
            _vm._v(" "),
            _c("text-area-row", {
              attrs: {
                title: "Expanded.BudgetaryEstimate.ChangesToBudgetaryEstimate",
                id: "changes",
                required: true,
                maxLength: 500,
                rows: 5
              },
              model: {
                value: _vm.budgetaryEstimate.changesToBudgetaryEstimate,
                callback: function($$v) {
                  _vm.$set(
                    _vm.budgetaryEstimate,
                    "changesToBudgetaryEstimate",
                    $$v
                  )
                },
                expression: "budgetaryEstimate.changesToBudgetaryEstimate"
              }
            })
          ],
          1
        )
      : _c("div", [
          _c("p", [_vm._v(_vm._s(_vm.$t("BudgetaryEstimate.ProcurationOnly")))])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }